import { Link } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  useSeo({
    title: '页面未找到 - 妖精动漫网',
    description: '您访问的页面不存在。返回妖精动漫网首页，继续查看妖精角色百科与声优表。',
  });

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <p className="font-heading text-7xl font-black text-primary-200">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">这片林子里没有你要找的页面</h1>
      <p className="mt-3 max-w-md text-sm leading-6 text-foreground-600">
        链接可能已失效，或页面被移动到了别处。返回首页，继续探索妖精角色百科与声优表吧。
      </p>
      <div className="mt-8 flex gap-3">
        <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap hover:bg-primary-600 transition-colors">
          <i className="ri-home-line" />
          返回首页
        </Link>
        <Link to="/characters" className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-6 py-2.5 text-sm font-medium text-foreground-700 whitespace-nowrap hover:bg-background-200 transition-colors">
          去角色百科
        </Link>
      </div>
    </div>
  );
}